export const isVideoMimeType = (mimeType: string) => {
    const videoMimeTypes = [
        "video/mp4",
        "video/webm",
        "video/ogg",
        "video/3gpp",
        "video/x-msvideo",
        "video/quicktime",
        "video/x-matroska",
        "video/x-flv",
        "video/x-ms-wmv",
        "video/mpeg",
    ]

    return videoMimeTypes.includes(mimeType)
}
